import React, { Component } from "react";
import { connect } from "react-redux";
import { Field } from "redux-form";
import { BaseComponent } from "BaseComponent";
import axios from "axios";
import GoogleMapReact from "google-map-react";
import AsyncSelect from "react-select/async";
import { locationDetails, geocode_coords } from "LocationMapActions";
import { GOOGLE_MAP_KEY, INSTANCE_URL, maxLengthObjectFc } from "Constants";
import { getHeaders } from "CommonUtils";
import MapMarker from "./map-marker";
import LocaleStrings from "Languages";
var MAXLENOBJ = {};
class LocationMapBody extends BaseComponent {
  constructor(props) {
    super(props);
    var lat = props.initialValues.latitude;
    var lng = props.initialValues.longitude;
    var locationName = props.initialValues.name;

    if (!locationName) {
      locationName = "";
    }

    this.state = {
      center: {
        lat: lat ? lat : -33.865143,
        lng: lng ? lng : 151.2099,
      },
      draggable: true,
      initialLoad: true,
      isLoading: false,
      selectedLocation: props.initialValues.location
        ? props.initialValues.location
        : "",
    };

    this.onMapClick = this.onMapClick.bind(this);
    this.onMapChange = this.onMapChange.bind(this);

    this.fetchAutocompleteSuggestions =
      this.fetchAutocompleteSuggestions.bind(this);
    this.onChangeCallback = this.onChangeCallback.bind(this);
    this.onCircleInteraction3 = this.onCircleInteraction3.bind(this);
    this.onCircleInteraction = this.onCircleInteraction.bind(this);

    /*if(!props.initialValues.mapid)
      this.fetchLocationData();*/
  }

  componentDidMount() {
    MAXLENOBJ = maxLengthObjectFc(this.props.history); // filter This form name object With route
  }

  // Search locations
  fetchAutocompleteSuggestions(input, callback) {
    if (input.length > 2) {
      this.setState({ isLoading: true });
      var params = { input: input };
      var url = `${INSTANCE_URL}/api/v2/eventifyscript_support?type=search_location`;

      return axios
        .post(url, params, getHeaders(this.props.session))
        .then(({ data }) => {
          var options = [];
          if (data.result.length > 0) {
            data = data.result[0];
          }

          if (data?.predictions?.length > 0) {
            data.predictions.map((item, index) => {
              //options.push({ name: item.description, placeid: item.place_id });
              options.push({ label: item.description, value: item.place_id });
            });
          }

          this.setState({ isLoading: false });
          return options;
          return {
            options: options,
          };
        })
        .catch((error) => {
          this.setState({ isLoading: false });
          return {
            options: [],
          };
        });
    } else {
      callback(null);
    }
  }

  // Select location
  onChangeCallback(event, callback) {
    if (event) {
      this.setState({
        ...this.state.center,
        selectedLocation: event,
      });

      this.props.locationDetails(
        this.props.session,
        { placeid: event.value },
        (data) => {
          if (data.result) {
            var locationData = data.result;
            this.setState({
              center: {
                lat: locationData.geometry.location.lat,
                lng: locationData.geometry.location.lng,
              },
              initialLoad: true, // Updating initialLoad as true because, When we are opening the modal GoogleMapReact onChange function is getting called and state is updated to false. So on every searched value select update this state to true.
            });
            locationData = { ...locationData, formatted_address: event.label };
            this.processData(locationData, true);
          }
        }
      );
    } else {
      this.setState({
        selectedLocation: { label: "", value: "" },
      });
    }
  }

  processData = (locationData, onselection) => {
    // debugger;
    var formattedData = this.formatData(locationData);
    formattedData = {
      ...formattedData,
      location: {
        label: locationData.formatted_address,
        value: locationData.place_id,
      },
    };

    setTimeout(() => {
      this.populateFields(formattedData, onselection);
    }, 1000);
  };

  onMapChange({ center, zoom }) {
    this.setState({
      center: {
        lat: center.lat,
        lng: center.lng,
      },
      zoom,
    });
    if (!this.state.initialLoad) {
      this.fetchLocationData();
    } else {
      this.setState({ initialLoad: false });
    }
  }

  onMapClick(event) {
    var lat = event.lat;
    var lng = event.lng;

    this.setState({
      center: {
        lat,
        lng,
      },
      zoom: 0,
    });

    if (!this.state.initialLoad) {
      this.fetchLocationData();
    }
  }

  fetchLocationData = () => {
    this.props.geocode_coords(
      this.props.session,
      { latlng: `${this.state.center.lat},${this.state.center.lng}` },
      (data) => {
        if (data.results.length > 0) {
          var locationData = data.results[0];
          this.processData(locationData, false);
        }
      }
    );
  };

  formatData = (place) => {
    var address = { city: "", state: "", country: "", postalcode: "" };
    for (var i = 0; i < place.address_components.length; i++) {
      var addressType = place.address_components[i].types[0];
      switch (addressType) {
        case "locality":
          address.city = place.address_components[i].long_name;
          break;
        case "administrative_area_level_1":
          address.state = place.address_components[i].long_name;
          break;
        case "country":
          address.country = place.address_components[i].long_name;
          break;
        case "postal_code":
          address.postalcode = place.address_components[i].long_name;
          break;
      }
    }

    return address;
  };

  populateFields = (data, onselection) => {
    if (!onselection) this.props.change("location", data.location);
    this.props.change("city", data.city);
    this.props.change("zipcode", data.postalcode);
    this.props.change("state", data.state);

    // console.log("this.state.center :- ", this.state.center);

    this.props.change("latitude", this.state.center.lat);
    this.props.change("longitude", this.state.center.lng);
  };

  onCircleInteraction(childKey, childProps, mouse) {
    // function is just a stub to test callbacks
    this.setState({
      draggable: false,
      center: {
        lat: mouse.lat,
        lng: mouse.lng,
      },
    });
  }

  onCircleInteraction3(childKey, childProps, mouse) {
    this.setState({ draggable: true });
    // function is just a stub to test callbacks
  }

  renderSelectLocation(field) {
    var divClassName = `form-group row ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass}`;

    return (
      <div className={divClassName}>
        <label className="control-label col-sm-3">
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>
        </label>
        <div className="col-sm-9 col-sm-offset-0">
          {/* Old codes <Select.Async */}
          <AsyncSelect
            className="booth-select-plus"
            {...field.input}
            isMulti={false}
            value={field.input.value || ""}
            valueKey={field.valueKey}
            placeholder={field.placeholder}
            labelKey={field.labelKey}
            loadOptions={field.loadOptions}
            onBlur={() => field.input.onBlur(field.input.value)}
            defaultInputValue={field.defaultInputValue || ""}
            backspaceRemoves={true}
            clearable={false}
          />
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  render() {
    var { handleSubmit, invalid, pristine, submitting } = this.props;

    var style = {
      height: "250px",
    };

    var mapStyle = {
      paddingTop: "5px",
      paddingRight: "15px",
      paddingLeft: "13%",
    };

    var { center } = this.state;

    return (
      <div className="basicform" style={{ paddingRight: "20px" }}>
        <Field
          name="name"
          label={LocaleStrings.map_label_name}
          placeholder={LocaleStrings.map_label_placeholder}
          component={this.renderFieldText}
          mandatory="true"
          maxlength={MAXLENOBJ.name ? MAXLENOBJ.name : ""}
        />
        <Field
          name="location"
          label={LocaleStrings.map_label_address}
          placeholder={LocaleStrings.map_placeholder_address}
          component={this.renderSelectLocation}
          mandatory="true"
          loadOptions={this.fetchAutocompleteSuggestions}
          onChange={this.onChangeCallback}
          labelKey="label"
          valueKey="value"
          isLoading={this.state.isLoading}
          value={this.state.selectedLocation}
          defaultInputValue={this.state.selectedLocation} // Default select while edit
          onBlurResetsInput={false}
        />

        <Field
          name="city"
          label={LocaleStrings.map_label_city}
          placeholder={LocaleStrings.map_placeholder_city}
          component={this.renderFieldText}
          mandatory="false"
        />
        <Field
          name="state"
          label={LocaleStrings.map_label_state}
          placeholder={LocaleStrings.map_placeholder_state}
          component={this.renderFieldText}
          mandatory="false"
        />
        <Field
          name="zipcode"
          label={LocaleStrings.map_label_zipcode}
          placeholder={LocaleStrings.map_placeholder_zipcode}
          component={this.renderFieldText}
          mandatory="false"
        />
        <Field
          name="latitude"
          label=""
          placeholder=""
          component={this.renderHiddenFieldText}
          mandatory="false"
        />
        <Field
          name="longitude"
          label=""
          placeholder=""
          component={this.renderHiddenFieldText}
          mandatory="false"
        />
        <div className="row" style={mapStyle}>
          <div
            className="col-sm-11 col-xs-offset-1"
            style={{ position: "relative" }}
          >
            <GoogleMapReact
              center={center}
              defaultZoom={14}
              style={style}
              bootstrapURLKeys={{ key: GOOGLE_MAP_KEY }}
              onClick={this.onMapClick}
              draggable={this.state.draggable}
              onChange={this.onMapChange}
            >
              <MapMarker lat={center.lat} lng={center.lng} />
            </GoogleMapReact>
          </div>
        </div>
      </div>
    );
  }
}
export default connect(null, { locationDetails, geocode_coords })(
  LocationMapBody
);
